import * as React from 'react';
import { UndergroundIcon } from '../../../containers/UndergroundIcon';
import { DefaultUndergroundIcon } from '../DefaultUndergroundIcon';
import * as styles from './styles.css';

export interface IMetroProps {
  metroColor?: string | null;
  locationId?: number;
  metro: string;
  metroDistance?: string | null;
}

export function Metro({ metroColor, locationId, metro, metroDistance }: IMetroProps) {
  const metroDistanceView = <span className={styles['metro-distance']}>{metroDistance}</span>;

  return (
    <div className={styles['metro-container']} data-testid="metro_block">
      {metroColor && (
        <div className={styles['metro-icon']}>
          {locationId ? (
            <span style={{ color: metroColor }}>
              <UndergroundIcon regionId={locationId} />
            </span>
          ) : (
            <DefaultUndergroundIcon color={metroColor} />
          )}
        </div>
      )}
      <div className={styles['metro-name']}>
        {metro}
        {metroDistanceView}
      </div>
    </div>
  );
}
